import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
const ResultCategoriesRadioButtonList = ({ trialName, distinctResultCategories, currentResultCategoryID, handleResultCategoryClick, }) => {
    return (React.createElement(Stack, { sx: {
            zIndex: 10000,
        }, alignItems: "center", justifyContent: "start", direction: {
            xs: "column",
            sm: "row",
        } },
        React.createElement(Typography, { variant: "body1", sx: {
                padding: "10px 10px 0px 0px", fontWeight: "bold",
                color: "#005533"
            } }, "Category"),
        distinctResultCategories.map((category, index) => (React.createElement(Box, { key: index, onClick: () => handleResultCategoryClick(category.id) },
            React.createElement(Typography, { variant: "body1", sx: {
                    textAlign: "center",
                    marginRight: "15px",
                    cursor: "pointer",
                    padding: "0px 0px 0px 0px",
                    fontSize: "1.0em",
                    color: "#005533",
                } },
                currentResultCategoryID === category.id ? (React.createElement(RadioButtonChecked, { sx: {
                        color: "#005533",
                        margin: "10px 0px 0px 0px",
                        padding: "10px 0px 0px 0px",
                        fontSize: "1.5em",
                    } })) : (React.createElement(RadioButtonUnchecked, { sx: {
                        color: "#005533",
                        margin: "10px 0px 0px 0px",
                        padding: "10px 0px 0px 0px",
                        fontSize: "1.5em",
                    } })),
                " ",
                category.categoryName))))));
};
export default ResultCategoriesRadioButtonList;
